import { GraphQLError } from 'graphql'

/**
 * `GraphQLResponseError` wraps error
 * response from the GraphQL API
 */
export class GraphQLResponseError extends Error {
  isGraphQLResponseError = true
  errors: GraphQLError[]

  constructor(errors: GraphQLError[]) {
    super(
      errors.reduce(
        (acc, curr) => (acc ? `${acc}. ${curr.message}` : curr.message),
        ''
      )
    )
    this.name = 'GraphQLResponseError'
    this.errors = errors
  }
}
